<template>
  <div class="content-wrappper">
    <div class="row tool-container">
      <div class="col-md-12 col-sm-12 col-xs-12 pr-0 pl-0">
        <router-view></router-view>
      </div>
      <!-- <div class="col-md-4 col-sm-5 col-xs-12">
        <div class="row">
           <div class="col-md-12 xs-pl-25 pl-0 pr-25" v-if="path === 'tools'">
            <tool-ad />
          </div>
          <div class="col-md-offset-1 col-md-11 marketing-box" v-else>
            <ad />
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>

export default {
  props: [],
  data() {
    return {
      path: '',
    };
  },
  components: {
  },
  methods: {},
  watch: {
    $route() {
      this.path = this.$route.path.split('/').pop();
    },
  },
  created() {
    this.path = this.$route.path.split('/').pop();
  },
};
</script>
<style scoped>
.marketing-box {
  padding-right: 2px;
}
.tool-container {
  margin-right: 0px;
  margin-left: 0px;
  background-color: #E5E5E5;

}
.pr-25 {
  padding-right: 25px;
}
@media screen and (max-width: 767px) {
    .xs-pl-25 {
        padding-left: 25px;
    }
}
</style>
